module.exports = __webpack_public_path__ + "img/green-arrow.81f79ae3.svg";